import { cn } from "@/lib/utils"

export interface AvatarImageProps {
  src: string
  alt?: string
  className?: string
}

/** Avatar/foto circular sem `backgroundImage` inline. */
export function AvatarImage({ src, alt = "", className }: AvatarImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={cn("size-full object-cover object-center", className)}
      loading="lazy"
      decoding="async"
    />
  )
}
